import { GALLERY } from "@/lib/site";

export const Gallery = () => {
  return (
    <section className="bg-white border-y border-[var(--border)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-7">
            <div className="eyebrow">Inside the building</div>
            <h2 className="section-title text-[44px] md:text-[64px] mt-4 leading-[1.02]">
              Light, line, and a little <em className="italic text-[var(--primary)]">restraint</em>.
            </h2>
          </div>
          <div className="md:col-span-5 flex md:items-end">
            <p className="text-[15px] text-[var(--text-muted)] leading-relaxed max-w-md">
              Photographs of the lobby, conference floor, and a selection of
              available suites. Tour any of them on request.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-3 md:gap-4">
          <figure className="col-span-12 md:col-span-8 aspect-[16/10] overflow-hidden hairline bg-[var(--bg)]">
            <img src={GALLERY[0].src} alt={GALLERY[0].caption} loading="lazy" className="w-full h-full object-cover" />
          </figure>
          <figure className="col-span-12 md:col-span-4 aspect-[4/5] overflow-hidden hairline bg-[var(--bg)]">
            <img src={GALLERY[1].src} alt={GALLERY[1].caption} loading="lazy" className="w-full h-full object-cover" />
          </figure>
          <figure className="col-span-6 md:col-span-4 aspect-[4/5] overflow-hidden hairline bg-[var(--bg)]">
            <img src={GALLERY[2].src} alt={GALLERY[2].caption} loading="lazy" className="w-full h-full object-cover" />
          </figure>
          <figure className="col-span-6 md:col-span-4 aspect-[4/5] overflow-hidden hairline bg-[var(--bg)]">
            <img src={GALLERY[3].src} alt={GALLERY[3].caption} loading="lazy" className="w-full h-full object-cover" />
          </figure>
          <figure className="col-span-12 md:col-span-4 aspect-[4/5] overflow-hidden hairline bg-[var(--bg)]">
            <img src={GALLERY[4].src} alt={GALLERY[4].caption} loading="lazy" className="w-full h-full object-cover" />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
